__turbopack_context__.v({
  "fadeInItems": "news-module__wZZgyW__fadeInItems",
  "morePost": "news-module__wZZgyW__morePost",
  "morePosts": "news-module__wZZgyW__morePosts",
  "spacing--lg": "news-module__wZZgyW__spacing--lg",
  "spacing--md": "news-module__wZZgyW__spacing--md",
  "spacing--sm": "news-module__wZZgyW__spacing--sm",
  "spacing--xl": "news-module__wZZgyW__spacing--xl",
  "spacing--xs": "news-module__wZZgyW__spacing--xs",
  "spacing--xxl": "news-module__wZZgyW__spacing--xxl",
  "spacing--xxs": "news-module__wZZgyW__spacing--xxs",
  "spacing--xxxl": "news-module__wZZgyW__spacing--xxxl",
  "spacing--xxxs": "news-module__wZZgyW__spacing--xxxs",
});
